// extracted by mini-css-extract-plugin
module.exports = {"a11y-visually-hidden":"file-upload_a11y-visually-hidden__2F8ed","a11YVisuallyHidden":"file-upload_a11y-visually-hidden__2F8ed"};